import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import css from './index.module.scss';
import Modal2 from './Modal2';

type ImgItemType = {
    img: string;
    text: string;
    desc?: string;
};
export default function B() {
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');
    const { locale = 'us' } = useRouter();
    const [itemsEnter, setItemsEnter] = useState<boolean>(false);
    const [btnEnter, setBtnEnter] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const box4Items: ImgItemType[] = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)
        ? [
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640835265/C_4A.png',
                  text: t('C_box4_text1'),
                  desc: t('C_box4_text1_desc'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640834514/C_4B.png',
                  text: t('C_box4_text2'),
                  desc: t('C_box4_text2_desc'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640835063/C_4C.png',
                  text: t('C_box4_text3'),
                  desc: t('C_box4_text2_desc'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640834874/C_4D.png',
                  text: t('C_box4_text4'),
                  desc: t('C_box4_text2_desc'),
              },
          ]
        : [
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640835265/C_4A.png',
                  text: t('C_box4_text1'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640834514/C_4B.png',
                  text: t('C_box4_text2'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640835063/C_4C.png',
                  text: t('C_box4_text3'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640834874/C_4D.png',
                  text: t('C_box4_text4'),
              },
              {
                  img: 'https://websiteoss.ecoflow.com/upload/image/1735640917200/C_4E.png',
                  text: t('C_box4_text5'),
              },
          ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window?.innerWidth > 1024) {
                const scene1 = AniContainer.create({
                    triggerElement: '.OASIS-B',
                    triggerHook: 1,
                    offset: '120%',
                    duration: '200%',
                    onEnter: () => setItemsEnter(true),
                    onLeave: () => setItemsEnter(false),
                });
                const scene2 = AniContainer.create({
                    triggerElement: '.OASIS-B',
                    triggerHook: 1,
                    offset: '180%',
                    duration: '220%',
                    onEnter: () => setBtnEnter(true),
                    onLeave: () => setBtnEnter(false),
                });
                return () => {
                    scene1.destroy();
                    scene2.destroy();
                };
            } else {
                const winH = window.innerHeight;
                const winW = window.innerWidth;
                const box4Lists: HTMLUListElement | null = document.querySelector('.OASIS-B .items');
                const box4Item: HTMLUListElement | null = document.querySelector('.OASIS-B .items .item');
                const scene1 = AniContainer.create({
                    asyncFromTo: [
                        [
                            box4Lists,
                            { x: (winW - Number(box4Item?.offsetWidth)) / 2 },
                            { x: winW / 2 - Number(box4Lists?.offsetWidth) + Number(box4Item?.offsetWidth) / 2 },
                            8,
                        ],

                        ['.OASIS-B .items .item-1 .item-text', { opacity: 1 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-1 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-1 .ef-img', { scale: 1.4 }, { scale: 1 }, 1],

                        ['.OASIS-B .items .item-2 .ef-img', { scale: 1 }, { scale: 1.4 }, 1.75],
                        ['.OASIS-B .items .item-2 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-2 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-2 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.OASIS-B .items .item-3 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.OASIS-B .items .item-3 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-3 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-3 .ef-img', { scale: 1.4 }, { scale: 1 }, 2],

                        ['.OASIS-B .items .item-4 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.OASIS-B .items .item-4 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-4 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-4 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.OASIS-B .items .item-5 .ef-img', { scale: 1 }, { scale: 1.4 }, 1],
                        ['.OASIS-B .items .item-5 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                    ],
                    asyncTimeLine: [
                        // 8份=> 1 : 2 : 2 : 2 : 1
                        0,
                        // 1份
                        0, 0.5, 0,
                        // 2份
                        0.5, 1.25, 2.5, 2.25,
                        // 2份
                        2, 3.5, 4.5, 4,
                        // 2份
                        4, 4.5, 6, 5.75,
                        // 1份
                        6.5, 6.75,
                    ],
                    triggerElement: '.OASIS-B .items',
                    triggerHook: 1,
                    duration: winH,
                    offset: '100%',
                });
                const scene2 = AniContainer.create({
                    triggerElement: '.OASIS-B',
                    triggerHook: 1,
                    offset: '180%',
                    duration: '220%',
                    onEnter: () => setBtnEnter(true),
                    onLeave: () => setBtnEnter(false),
                });
                return () => {
                    scene1.destroy();
                    scene2.destroy();
                };
            }
        }
    }, []);

    return (
        <>
            <EfSpec />
            <section className={`OASIS-B ${css['OASIS-B']}`}>
                <div className="box">
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box4_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box4_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="items-sticky">
                        <ul className={`items ${itemsEnter ? 'enter' : ''}`}>
                            {box4Items.map((item, k) => (
                                <li className={`item item-${k + 1}`} key={k}>
                                    <div className={`item-inner item-inner-${k}`}>
                                        <div className="item-img">
                                            <EfImg pc={item.img} />
                                        </div>
                                        <p className="item-text">{item.text}</p>
                                        <p className="item-desc">{item.desc}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <button className={`btn ${btnEnter ? 'enter' : ''}`} onClick={() => setIsOpen(true)}>
                        <span className="btn-text">{t('C_box4_btn')}</span>
                        <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                    </button>
                </div>
                {isOpen && createPortal(<Modal2 type={isOpen} callback={() => setIsOpen(false)} />, document.body)}
            </section>
        </>
    );
}
